export default __webpack_public_path__ + "static/media/hire-profile.48dfa008.png";